import { render, staticRenderFns } from "./RightElement.vue?vue&type=template&id=0cefff4f&scoped=true&"
import script from "./RightElement.vue?vue&type=script&lang=js&"
export * from "./RightElement.vue?vue&type=script&lang=js&"
import style0 from "./RightElement.vue?vue&type=style&index=0&id=0cefff4f&scoped=true&lang=scss&"
import style1 from "./RightElement.vue?vue&type=style&index=1&id=0cefff4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cefff4f",
  null
  
)

export default component.exports